import { get } from 'lodash-es';

/**
 * This method prepares fare-data for use by the app whether it comes from
 * the OTP1 or OTP2 data-source
 * @param {Object} itinerary
 * @returns {Object} - bespoke fare data for the itinerary in question
 * @TODO - Does this properly condense all of the trip costs including
 * transfers between Trimet, C-Tran, and other providers' fare costs?
 * https://trimet.atlassian.net/browse/PRJ77-489
 */
export const extractFare = itinerary => {
  const fareCents = get(itinerary, 'fare.cents');
  const fareCurrencyCode = get(itinerary, 'fare.currencyCode');
  const regularFareCents = get(itinerary, 'fare.fare.regular.cents');
  const regularCurrencyCode = get(
    itinerary,
    'fare.fare.regular.currency.currencyCode'
  );
  const legProductCents = get(
    itinerary,
    'fare.legProducts[0].products[0].amount.cents'
  );
  const legProductCurrencyCode = get(
    itinerary,
    'fare.legProducts[0].products[0].amount.currency.currencyCode'
  );

  if (regularFareCents !== undefined && regularCurrencyCode !== undefined) {
    return { cents: regularFareCents, currencyCode: regularCurrencyCode };
  }
  if (fareCents !== undefined && fareCurrencyCode !== undefined) {
    return { cents: fareCents, currencyCode: fareCurrencyCode };
  }
  if (legProductCents !== undefined && legProductCurrencyCode !== undefined) {
    return { cents: legProductCents, currencyCode: legProductCurrencyCode };
  }
  return null;
};

export default extractFare;
